import styled from 'styled-components';

import { mixins } from '../../../../../style/mixins';

export const Wrapper = styled.div(({ theme: { color, size } }) => ({
  borderTop: `1px solid ${color.border.secondary.default()}`,
  padding: `${size.units(2)} ${size.units(4)}`,
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  ...mixins.responsive.sm.downward({
    flexFlow: 'column wrap',
    gap: 8,
    flexDirection: 'column',
  }),
}));

export const ButtonsWrapper = styled.div({
  height: 'auto',
  width: '100%',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'row-reverse',
  justifyContent: 'start',
  '-webkit-justify-content': 'flex-start',
  gap: 20,
  ...mixins.responsive.sm.downward({
    flexFlow: 'column wrap',
    gap: 8,
    flexDirection: 'column',
  }),
});

export const ButtonWrapper = styled.div({
  width: 'fit-content',
  ...mixins.responsive.sm.downward({
    width: '100%',
  }),
});
